import { useEffect, useState } from "react";
import api from "@/lib/api";
import { visitorCountry } from "@/lib/geo";

let cached = null;

const PREVIEW_KEY = "rf_preview_theme";

export function previewThemeId() {
  const q = new URLSearchParams(window.location.search).get("preview_theme");
  if (q) sessionStorage.setItem(PREVIEW_KEY, q);
  return sessionStorage.getItem(PREVIEW_KEY);
}

export function exitThemePreview() {
  sessionStorage.removeItem(PREVIEW_KEY);
  window.location.href = window.location.pathname;
}

const liveTheme = () => visitorCountry().then((cc) => api.get(`/seasonal-theme?country=${cc}`)).then((r) => r.data || null);

function loadTheme() {
  if (!cached) {
    const pid = previewThemeId();
    const pick = pid
      ? api.get(`/admin/seasonal-themes/${pid}/preview`).then((r) => ({ ...r.data, preview: true }))
        .catch(() => { sessionStorage.removeItem(PREVIEW_KEY); return liveTheme(); })
      : liveTheme();
    cached = pick.catch(() => null);
  }
  return cached;
}

export function SeasonalPreviewBar() {
  const theme = useSeasonalTheme();
  if (!theme?.preview) return null;
  return (
    <div className="bg-rf-ink text-rf-cream text-sm px-4 py-2 flex items-center justify-center gap-3" data-testid="seasonal-preview-bar">
      <span>Previewing <b>{theme.name}</b>. Only admins can see this.</span>
      <button type="button" onClick={exitThemePreview} className="underline font-bold" data-testid="seasonal-preview-exit">Exit preview</button>
    </div>
  );
}

export function useSeasonalTheme() {
  const [theme, setTheme] = useState(null);
  useEffect(() => { let on = true; loadTheme().then((t) => on && setTheme(t)); return () => { on = false; }; }, []);
  return theme;
}

// Main pages only — /historical/:slug are recipe pages, so only the hub and region lists get the strip.
const STRIP_PATHS = ["/directory", "/pricing", "/faqs", "/news", "/kitchen-help", "/historical/region"];
const EXACT_PATHS = ["/historical"];

export function SeasonalStrip({ pathname }) {
  const theme = useSeasonalTheme();
  if (!theme?.strip_url || !(EXACT_PATHS.includes(pathname) || STRIP_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)))) return null;
  const url = `${process.env.REACT_APP_BACKEND_URL}${theme.strip_url}`;
  return (
    <div
      role="img"
      aria-label={`${theme.name} decoration`}
      data-testid="seasonal-strip"
      className="h-24 md:h-28 w-full bg-repeat-x"
      style={{ backgroundImage: `url(${url})`, backgroundSize: "auto 300%", backgroundPosition: "center" }}
    />
  );
}
